import { useEffect, useMemo, useState } from 'react';
import { VehicleCarouselSection } from './VehicleCarouselSection';

type StockTab = 'zerokm' | 'seminovo';

interface FeaturedListingsProps {
  vehicles: any[];
  store: any;
}

export function FeaturedListings({ vehicles, store }: FeaturedListingsProps) {
  const [stockTab, setStockTab] = useState<StockTab>('zerokm');

  const zeroKmVehicles = useMemo(
    () => vehicles.filter((v) => v.isZeroKm || v.mileage === 0),
    [vehicles]
  );
  const usedVehicles = useMemo(
    () => vehicles.filter((v) => !v.isZeroKm && v.mileage > 0 && !v.armored),
    [vehicles]
  );

  const showcaseSource = useMemo(() => {
    const featured = vehicles.filter(
      (v) =>
        v.changed?.featured ||
        (v.statistics?.views && v.statistics.views > 100) ||
        (v.statistics?.favorites && v.statistics.favorites > 3)
    );
    return featured.length > 0 ? featured : vehicles;
  }, [vehicles]);

  const tabs = useMemo(
    () =>
      [
        {
          id: 'zerokm',
          label: 'Zero KM',
          show: !!store?.ad?.showZeroKm && zeroKmVehicles.length > 0,
        },
        {
          id: 'seminovo',
          label: 'Seminovos',
          show: !!store?.ad?.showUsed && usedVehicles.length > 0,
        },
      ]
        .filter((tab) => tab.show)
        .map(({ id, label }) => ({ id, label })),
    [store?.ad?.showZeroKm, store?.ad?.showUsed, zeroKmVehicles.length, usedVehicles.length]
  );

  useEffect(() => {
    if (!tabs.find((tab) => tab.id === stockTab)) {
      setStockTab((tabs[0]?.id as StockTab) ?? 'zerokm');
    }
  }, [stockTab, tabs]);

  const displayVehicles = useMemo(() => {
    let list = showcaseSource;
    if (tabs.length > 0) {
      if (stockTab === 'zerokm') list = zeroKmVehicles;
      if (stockTab === 'seminovo') list = usedVehicles;
    }
    return list.slice(0, 12);
  }, [showcaseSource, stockTab, zeroKmVehicles, usedVehicles, tabs.length]);

  const viewAllHref =
    stockTab === 'zerokm' ? '/estoque?type=zerokm' : '/estoque?type=seminovo';

  return (
    <VehicleCarouselSection
      id="ofertas"
      title={store.featuredTitle || 'Destaques'}
      viewAllHref={viewAllHref}
      vehicles={displayVehicles}
      tabs={tabs.length > 1 ? tabs : undefined}
      activeTab={stockTab}
      onTabChange={(id) => setStockTab(id as StockTab)}
    />
  );
}
